// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing.spacing120} 0 ${theme.spacing.spacing60}`};
  margin: ${({ theme }) =>
    `0 ${theme.spacing.spacing100} ${theme.spacing.spacing40} ${theme.spacing.spacing100}`};
  padding-bottom: ${({ theme }) => theme.spacing.spacing100};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};

  .stars {
    .star-rating {
      height: 24px;
      margin-right: ${({ theme }) => theme.spacing.spacing40};
    }
  }
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${({ theme }) => `${theme.spacing.spacing120} ${theme.spacing.spacing160}`};
    margin: 0;
  }

  @media (min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP}) {
    flex-direction: row;
  }
`;

export const RatingContainer = styled.div`
  width: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-bottom: ${({ theme }) => `${theme.spacing.spacing120}`};
  }
`;

export const RatingBarOuterContainer = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.spacing100};

  @media screen and (min-width: ${BREAKPOINTS.TABLET}px) {
    justify-content: start;
    margin-top: 0;
  }
`;

export const RatingCount = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing60};
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleXLarge}

  .maxCount {
    color: ${({ theme }) => theme.colors.textDisabled};
    ${({ theme }) => theme.typography.type320};
  }
`;

export const BasedOnDark = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  text-align: center;
  margin: ${({ theme }) => `${theme.spacing.spacing60} auto 0`};
  ${({ theme }) => theme.typography.bodyMedium}
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

export const PlaceholderRow = styled.div`
  width: 100%;
  height: 17px;
  background: ${({ theme }) => theme.colors.surface20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  max-width: 400px;

  &.starRating {
    width: 120px;
    height: 24px;
  }

  &.ratingCount {
    height: 40px;
    width: 85px;
  }

  &.basedOn {
    width: 190px;
    height: 12px;
    margin-bottom: ${({ theme }) => theme.spacing.spacing120};
  }
`;
